import React from 'react';
import { Link } from 'react-router-dom';
export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '10rem', lineHeight: 1, background: 'linear-gradient(135deg,#00ff88,#00e5ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', letterSpacing: '4px' }}>404</div>
      <p style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.85rem', color: '#5a5e72', marginBottom: '2rem', letterSpacing: '2px' }}>PAGE NOT FOUND — CARBON NOT SEQUESTERED HERE</p>
      <Link to="/" className="btn btn-primary">RETURN HOME</Link>
    </div>
  );
}
